import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHtml5, faCss3Alt, faJs, faReact, faCuttlefish, faNodeJs } from '@fortawesome/free-brands-svg-icons';
import { faServer } from '@fortawesome/free-solid-svg-icons';

const SkillsCom = () => {
    const [selectedSkill, setSelectedSkill] = useState('');

    const skills = [{
        name: 'HTML',
        icon: faHtml5,
        description: 'HTML (HyperText Markup Language) is the standard markup language for creating web pages and web applications. It defines the structure and layout of content using elements and tags.'
    }, {
        name: 'CSS',
        icon: faCss3Alt,
        description: 'CSS (Cascading Style Sheets) is a stylesheet language used for describing the presentation of a document written in HTML. It controls the layout, colors, fonts, and spacing of elements on a web page.'
    }, {
        name: 'JavaScript',
        icon: faJs,
        description: 'JavaScript is a high-level, interpreted programming language that is primarily used for adding interactivity to web pages. It allows you to create dynamic content, manipulate HTML and CSS, and interact with web browsers.'
    }, {
        name: 'React.js',
        icon: faReact,
        description: 'React.js is a JavaScript library for building user interfaces, particularly for single-page applications. It allows developers to create reusable UI components and efficiently manage the state of an application.'
    }, {
        name: 'AJAX / Axios',
        icon: faNodeJs,
        description: 'AJAX (Asynchronous JavaScript and XML) is a set of web development techniques that allows web pages to be updated asynchronously by exchanging small amounts of data with the server behind the scenes. Axios is a popular library used to make HTTP requests in JavaScript applications.'
    }, {
        name: 'REST API',
        icon: faServer,
        description: 'REST (Representational State Transfer) is an architectural style for designing networked applications. A RESTful API is an API that adheres to the principles of REST, allowing for interaction with web services using standard HTTP methods.'
    }, {
        name: 'C++',
        icon: faCuttlefish,
        description: 'C++ is a powerful, general-purpose programming language that supports procedural, object-oriented, and generic programming. It is widely used for developing system software, game engines, and high-performance applications.'
    }];

    const handleSkillClick = (skill) => {
        setSelectedSkill(skill === selectedSkill ? '' : skill);
    };

    return (
        <Container>
            <Header>Skills</Header>
            <SkillsContainer>
                {skills.map((skill, index) => (
                    <Skill key={index} active={skill.name === selectedSkill} onClick={() => handleSkillClick(skill.name)}>
                        <FontAwesomeIcon icon={skill.icon} size="2x" />
                        {skill.name}
                    </Skill>
                ))}
            </SkillsContainer>
            {selectedSkill && (
                <SkillDetails>
                    <SkillName>{selectedSkill}</SkillName>
                    <SkillDescription>{skills.find(skill => skill.name === selectedSkill).description}</SkillDescription>
                </SkillDetails>
            )}

        </Container>
    );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: black;
  color: #03ff2c;

`;

const Header = styled.h1`
  font-size: 3em;
  font-family: Consolas, monospace;
  margin-bottom: 20px;
  color: #03ff2c;
`;

const SkillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`;

const Skill = styled.button`
  font-size: 1.2em;
  padding: 10px 20px;
  border: 2px solid #03ff2c;
  border-radius: 8px;
  background-color: ${props => props.active ? '#03ff2c' : 'black'};
  color: ${props => props.active ? 'black' : '#03ff2c'};
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  font-family: Consolas, monospace;

  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    background-color: #03ff2c;
    color: black;
  }
`;

const SkillDetails = styled.div`
  margin-top: 20px;
  text-align: left;
`;

const SkillName = styled.h2`
  font-size: 2em;
  font-family: Consolas, monospace;
`;

const SkillDescription = styled.p`
  font-size: 1em;
  font-family: Consolas, monospace;
`;

export default SkillsCom;
